const React = require('react');
const { bool, shape, string } = require('prop-types');

const AcquiHeroSection = require('@acqui-calm-library/acqui-hero-section');
const AcquiNexusSection = require('@acqui-calm-library/acqui-nexus-section');
const AcquiTycSection = require('@acqui-calm-library/acqui-tyc-section');

const AcquisitionComponent = ({
  id,
  config,
  type,
  isMobile,
  isWebView,
  theme,
  sectionMetadata,
  formRequestMetadata,
}) => {
  switch (type) {
    case 'acqui-hero-section':
      return (
        AcquiHeroSection && (
          <AcquiHeroSection
            {...config}
            id={id}
            isMobile={isMobile}
            isWebView={isWebView}
            andesTheme={theme}
            sectionMetadata={sectionMetadata}
            requestMetadata={formRequestMetadata}
          />
        )
      );
    case 'acqui-nexus-section':
      return (
        AcquiNexusSection && (
          <AcquiNexusSection
            {...config}
            id={id}
            isMobile={isMobile}
            isWebView={isWebView}
            andesTheme={theme}
            sectionMetadata={sectionMetadata}
            requestMetadata={formRequestMetadata}
          />
        )
      );
    case 'acqui-tyc-section':
      return (
        AcquiTycSection && (
          <AcquiTycSection
            {...config}
            id={id}
            isMobile={isMobile}
            isWebView={isWebView}
            andesTheme={theme}
            sectionMetadata={sectionMetadata}
            requestMetadata={formRequestMetadata}
          />
        )
      );

    default:
      return null;
  }
};

AcquisitionComponent.propTypes = {
  id: string,
  type: string,
  config: shape({
    lazyMode: string,
  }),
  sectionMetadata: shape({
    type: string,
    sectionId: string,
    sectionVersionId: string,
  }),
  isMobile: bool,
  isWebView: bool,
  theme: string,
  formRequestMetadata: shape({
    landing_group_id: string,
    variant_name: string,
    landing_id: string,
    uuid: string,
    utm_campaign: string,
    utm_content: string,
    utm_medium: string,
    utm_source: string,
    utm_term: string,
  }),
};

module.exports = { AcquisitionComponent };
